<template>
  <div id="app">
    <header>
      <span>Restoku Dashboard {{ title }}</span>
      <a href="#" v-if="isLogin" @click="logout">
        <img src="https://img.icons8.com/windows/32/FFFFFF/logout-rounded.png"/>
      </a>
    </header>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        title: ''
      }
    },
    methods: {
      logout () {
        localStorage.clear()
        this.$router.push('/login')
      }
    },
    computed: {
      isLogin () {
        if (localStorage.getItem('nama_toko')) {
          this.title = ' - ' + localStorage.getItem('nama_toko').toUpperCase()
          return localStorage.getItem('id_toko')
        } else {
          return 0
        }
      }
    },
    beforeMount () {
      if (!localStorage.getItem('id_toko') && this.$route.path !== '/login') {
        this.$router.push('/login')
      }
    }
  }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Karla:wght@400;700&display=swap');

  * {
    font-family: 'Karla', sans-serif;
  }

  body {
    margin: 0;
    background: #f7f7f7;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  header {
    margin: 0;
    height: 56px;
    padding: 0 16px 0 24px;
    background-color: #168BE3;
    color: #ffffff;

    span {
      display: block;
      position: relative;
      font-size: 20px;
      line-height: 1;
      letter-spacing: .02em;
      font-weight: 400;
      box-sizing: border-box;
      padding-top: 16px;
      text-align: center;
    }

    a {
      position: absolute;
      right: 15px;
      margin-top: -25px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/App.vue